<template>
	<v-simple-table class="main-table">
		<template v-slot:default>
			<tbody>
				<tr v-for="(entry, key) in displayData" :key="key" class="main-table__row">
					<td class="main-table__left">{{ entry.label }}</td>
					<td class="main-table__right"> {{ entry.value }}</td>
				</tr>
			</tbody>
		</template>
	</v-simple-table>
</template>
<script>
export default {
	props: {
		displayData: Array
	}
};
</script>
<style lang="scss" scoped>

.main-table {

    &__left {
        text-align: left;
        font-family: "IBM Plex Mono", monospace;
        color: #818180;
        font-size: 12px;
        border: 0px !important;
        line-height: 16px;
    }

    &__right {
        text-align: right;
        font-family: "IBM Plex Mono", monospace;
        color: black;
        font-size: 12px;
        border: 0px !important;
        line-height: 16px;
    }

}
</style>
